<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmh"><a id="page_vi"></a><span class="bold">Acknowledgements</span></h2>
<p class="noindent">I should like to thank the following for the help kindly given to me: Steven Spencer and colleagues at The Salvation Army International Heritage Centre, London; Lindsay Cox at The Salvation Army Australia Museum; Sarah Pearce at the Heritage Centre &amp; Archives of The Salvation Army NZFTS; Michael Nagy at The Salvation Army Southern Historical Centre, Evangeline Booth College, USA; Ronald Millar at The Salvation Army Archives, Canada and Bermuda Territory, Ontario, Canada; and to all those who generously posted material on Wikimedia Commons.</p>
<p class="indent">I should also like to thank the following for their help in allowing me the use of the materials in the epigrams: Adam Peardon-Cook at The Salvation Army Trading Company Ltd.; Rachel Twombly at Rowman &amp; Littlefield, USA.</p>
<p class="indent">While every effort has been made to trace the owners of copyright, if it is believed that there are errors or omissions, please notify the publishers in the first instance.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Acknow.vue?f39b0e46